/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Sum = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 14px;
  font-weight: 500;
  color: ${Palette.PrimaryGray._700};
`;

export const EventSum = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 4px;
  font-size: 14px;
  font-weight: 500;
  color: ${Palette.PrimaryGray._700};
  overflow: hidden;
`;

export const SumInner = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EventSums = styled.div`
  display: flex;
  height: 100%;
  border-left: 1px solid ${Palette.PrimaryGray._200};
`;

export const HeaderTitles = styled.div`
  display: flex;
  background-color: ${Palette.PrimaryGray._000};
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  user-select: none;
  text-align: center;
`;

export const HeaderSums = styled.div`
  display: flex;
  align-items: center;
  background-color: ${Palette.PrimaryGray._100};
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;

export const EventsWrap = styled.div`
  border-left: 1px solid ${Palette.PrimaryGray._200};

  &:last-of-type {
    flex-grow: 1;
  }
`;

export const EventsTitle = styled.div`
  height: 50%;
  width: 100%;
  font-size: 12px;
  padding: 8px 16px;
  color: ${Palette.PrimaryGray._500};
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;

export const EventList = styled.div`
  display: flex;
  flex-grow: 1;
  height: 50%;
  font-size: 12px;
  font-weight: 500;
  color: ${Palette.PrimaryGray._500};
`;

export const Event = styled.div`
  width: ${({ width }) => (width ? `${width}` : '120px')};
  height: 100%;
  padding: 8px;

  & > div {
    width: ${({ width }) => (width ? `${width}` : '120px')};
  }
`;

export const TextWrap = styled.div`
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
